import { UserCardV1 } from '@/shared/api';

import { CreditCardIcon } from './credit-card-icon';

type CreditCardProps = {
	card: UserCardV1;
};

export function CreditCard({ card }: CreditCardProps) {
	return (
		<div className="space-y-3 rounded-xl border border-gray-5 bg-white p-4 text-xs">
			<div className="text-gray-3">Привязанная карта</div>
			<div className="flex items-center gap-3 text-black">
				<CreditCardIcon firstSixDigits={card.firstSixDigits} /> ****{' '}
				{card.lastFourDigits}
			</div>
		</div>
	);
}
